
import { Component, Vue } from "vue-property-decorator";
import AdvantagesTable from "@/components/Main/Rings/AdvantagesTable.vue";

@Component({
    components: {
        AdvantagesTable
    }
})
export default class ProductInfo extends Vue {
    public activeProductPage: number = 1;

    public productInfo: any = {
        mainFeatures: [
            {
                name: 'Compatible with mobile devices',
                value: 'iOS 12 and above or Android 14+ and above'
            },
            {
                name: 'Bluetooth version',
                value: 'BLE 5.0'
            },
            {
                name: 'Bluetooth range',
                value: '2 meters'
            },
            {
                name: 'Battery',
                value: 'Rechargeable battery'
            },
            {
                name: 'Battery capacity',
                value: '14,5–21,5 мА·ч'
            },
            {
                name: 'Device memory',
                value: 'Data storage for the last 15 days'
            },
            {
                name: 'Water resistance',
                value: '5 ATM'
            },
            {
                name: 'Working time in active mode',
                value: 'up to 99 hours'
            },
            {
                name: 'Burned calories',
                value: 'up to 9000 calories'
            },
            {
                name: 'Running/walking distance',
                value: 'up to 999 km'
            },
            {
                name: 'Temperature range',
                value: 'from -10°C to +35°C'
            },
            {
                name:'Material',
                value: 'Aviation titanium, epoxy resin, hypoallergenic plastic'
            }
        ]
    }

   
}
